import Vue from "vue"
import VueRouter from "vue-router"
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "Home",
    // component: Home,
    redirect: "/my-account/profile"
  },
  {
    path: "/my-account/",
    name: "My Account",
    component: () => import("../views/MyAccount.vue"),
    children: [
      {
        name: "Dashboard",
        path: "/my-account/",
        redirect: "/my-account/profile", // temporary redirect to Profile for users incomplete profile
        component: () => import("../views/Dashboard.vue")
      },
      {
        name: "Profile",
        path: "/my-account/profile",
        component: () => import("../views/Profile.vue")
      },
      {
        name: "Account Info",
        path: "/my-account/profile/account-info",
        component: () => import("../components/myAccount/profileForms/accountInfoForm.vue")
      },
      {
        name: "Personal Info",
        path: "/my-account/profile/personal-info",
        component: () => import("../components/myAccount/profileForms/personalInfoForm.vue")
      },
      {
        name: "Location Info",
        path: "/my-account/profile/location-info",
        component: () => import("../components/myAccount/profileForms/locationInfoForm.vue")
      },
      {
        name: "Change Password",
        path: "/my-account/profile/change-password",
        component: () => import("../components/myAccount/profileForms/changePasswordForm.vue")
      },
      {
        name: "Contact Info",
        path: "/my-account/profile/contact-info",
        component: () => import("../components/myAccount/profileForms/contactInfoForm.vue")
      },
    ]
  },
  {
    path: "/casino/",
    name: "Casino",
    redirect: "/casino/muaythai",
    component: () => import("../views/Casino.vue"),
    children: [
      {
        name: "Casino Details",
        path: "/casino/muaythai",
        component: () => import("../views/CasinoDetails.vue")
      },
    ]
  },
  {
    // Temporary sandbox
    path: "/sandbox",
    name: "Sandbox",
    component: () => import("../views/_Sandbox.vue")
  },
  {
    path: "/*",
    name: "Other Pages",
    component: () => import("../views/Unavailable.vue")
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
})

export default router
